import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=4809fb64"
import script from "./Historico.vue?vue&type=script&lang=ts"
export * from "./Historico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports